import {
    DELETE_CANDIDATE_BY_ADMIN_REQUEST,
    DELETE_CANDIDATE_BY_ADMIN_SUCCESS,
    DELETE_CANDIDATE_BY_ADMIN_FAILURE,
} from "../actions";

const initialState = {
    loading: false,
    data: [],
    error: "",
};

const deleteCandidateByAdminReducer = (state = initialState, action) => {
    switch (action.type) {
        case DELETE_CANDIDATE_BY_ADMIN_REQUEST:
            return {
                ...state,
                loading: true,
                data: [],
            };

        case DELETE_CANDIDATE_BY_ADMIN_SUCCESS:
            return {
                loading: false,
                data: action.payload,
                error: "",
            };
        case DELETE_CANDIDATE_BY_ADMIN_FAILURE:
            return {
                loading: false,
                data: [],
                error: action.payload,
            };
        default:
            return state;
    }
};
export default deleteCandidateByAdminReducer;
